module.exports = __webpack_public_path__ + "img/ig.bee40830.svg";